import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";
import {FactoryService} from "../../../services/factory.service";
import {isUndefined} from "util";
import {WatchService} from "../../../services/watch.service";
import {JP} from "../../../helpers/jp";

@Component({
  selector: "go-work",
  templateUrl: "./go-work.component.html"
})


export class GoWorkComponent extends GoBaseComponent {
  UI_TEXTS = UI_TEXTS;
  JP = JP;

  public levelSettingsPropName:string = "levelSettings";

  constructor(private factoryService: FactoryService,
              private  watchService:WatchService) {
    super(GO_COMPONENTS.WORK);
  }


  get hasRepairAction() {
    return this.factoryService.gameObjectUtils.hasRepairAction(this.component);
  }


  get repairAction() {
    return this.component["repairAction"];
  }


  get toggleButtonLabel() {
    return this.hasRepairAction
      ? "Удалить"
      : "Добавить";
  }


  toggleRepairAction() {
    this.factoryService.gameObjectUtils.toggleRepairAction(this.component);
  }

  onAddLevelsSettingsClick(){
    if (isUndefined(this.component[this.levelSettingsPropName]))
    {
      this.component[this.levelSettingsPropName] = [];
    }
    this.component[this.levelSettingsPropName].push(this.factoryService.gameObjectUtils.createWorkplaceLevelSettings());
    this.watchService.notify();
  }

  onRemoveLevelsSettingsClick(idx:number){
    let c = this.component[this.levelSettingsPropName];
    c.splice(idx, 1);
    this.watchService.notify();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-work/go-work.component.ts